// extracted by mini-css-extract-plugin
export default {"time_off_modal":"TimeOffModal_time_off_modal__cKedS","body":"TimeOffModal_body__u7MEh","footer":"TimeOffModal_footer__a51R9"};